










import { ref, defineComponent } from '@vue/composition-api'
import snippets from '@/snippets'
import { Snippet } from '../../types/index'

export default defineComponent({
  name: 'Toolbar',
  setup () {
    const selectableSnippets = ref<Snippet[]>(Object.values(snippets))
    const selectedSnippetLabel = ref(selectableSnippets.value[0].label)

    return {
      snippets: selectableSnippets,
      selectedSnippetLabel
    }
  }
})
